export default __webpack_public_path__ + "static/media/lessons_blue_icon.39889d52.svg";